import ConsejoAcademico from  './ConsejoAcedemico';

export default ConsejoAcademico;